/* hs-eslint ignored failing-rules */

/* eslint-disable react/prop-types */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import UISearchInput from 'UIComponents/input/UISearchInput';
import I18n from 'I18n';
import { EntityTypes } from 'AdsUI/lib/Constants';

const CampaignsListTableSearch = ({
  campaignSearchQuery,
  onCampaignSearchChange,
  use,
  entityType,
  network
}) => {
  let searchPlaceholder = '';

  if (entityType === EntityTypes.CAMPAIGN) {
    searchPlaceholder = I18n.text(`campaigns.campaignTable.searchAdCampaign`);
  } else if (entityType === EntityTypes.SEQUENCE) {
    searchPlaceholder = I18n.text(`campaigns.campaignTable.searchAdSequences`);
  } else if (network && entityType) {
    searchPlaceholder = I18n.text(`campaigns.campaignTable.searchLabel.${network}.${entityType}`);
  }

  return /*#__PURE__*/_jsx(UISearchInput, {
    use: use,
    value: campaignSearchQuery,
    placeholder: searchPlaceholder,
    onChange: onCampaignSearchChange,
    className: "display-inline-block inline-search-input-header"
  });
};

CampaignsListTableSearch.propTypes = {
  campaignSearchQuery: PropTypes.string.isRequired,
  onCampaignSearchChange: PropTypes.func.isRequired
};
export default CampaignsListTableSearch;